
import React from 'react';
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Product } from "@/types";

export interface ProductRatingsProps {
  product: {
    rating_dank?: number;
    rating_earthy?: number;
    rating_pungent?: number;
    rating_dessert?: number;
    rating_fruity?: number;
    rating_citrus?: number;
  };
  onChange: (updates: Partial<Product>) => void;
}

const ProductRatings: React.FC<ProductRatingsProps> = ({
  product,
  onChange
}) => {
  const ratings = [
    { key: 'rating_dank', label: 'Dank' },
    { key: 'rating_earthy', label: 'Earthy' },
    { key: 'rating_pungent', label: 'Pungent' },
    { key: 'rating_dessert', label: 'Dessert' },
    { key: 'rating_fruity', label: 'Fruity' },
    { key: 'rating_citrus', label: 'Citrus' }
  ] as const;

  const handleInputChange = (field: string, value: string) => {
    const numValue = value === '' ? 0 : parseFloat(value);
    // Ensure the value stays between 0 and 5
    const clampedValue = Math.min(Math.max(numValue, 0), 5);
    onChange({ [field]: clampedValue });
  };

  return (
    <div className="space-y-6">
      {ratings.map(({ key, label }) => (
        <div key={key} className="space-y-2">
          <div className="flex justify-between">
            <Label htmlFor={key}>{label}</Label>
            <span className="text-sm text-muted-foreground">{product[key] || 0}/5</span>
          </div>
          <Input
            id={key}
            type="text"
            inputMode="decimal"
            value={product[key] || ''}
            onChange={(e) => handleInputChange(key, e.target.value)}
            placeholder="0-5"
          />
        </div>
      ))}
    </div>
  );
};

export default ProductRatings;
